import { render, staticRenderFns } from "./PickList.vue?vue&type=template&id=1a0b7c63"
import script from "./PickList.vue?vue&type=script&lang=js"
export * from "./PickList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports